import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useLazyQuery } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, ModalHeader, Button,
} from 'reactstrap';
import {
  handleGraphqlError, OFFER_STATUS,
  ARTIST_OFFER_LIST_STATUS, ARTIST_PRIVATE_REQUEST, BYGMUSIC_CONTRACT, capitalizeEveryWord, NUMERIC_VALUE,
} from '../../utils';
import CampaignTimeline, { isDateDiff } from '../shared/campaignTimeline/CampaignTimeline';
import Loading from '../shared/loadingOverlay/Loading';
import { GET_OFFER_DETAIL_QUERY, GET_USER_DATA_QUERY } from '../../graphql-client/queries';
import {
  REQUEST_ARTIST_PARTICIPATION, LOADER_MUTATION, REMOVE_PRIVATE_OFFER_CLIENT,
  UPDATE_PRIVATE_OFFER_REQUEST, ACCEPT_CONTRACT, UPDATE_OFFER_NOTIFICATION, PUBLISH_BETA_POST_REQUEST,
} from '../../graphql-client/mutations';
import CreateBetaPost from './CreateBetaPost';
import Message from '../shared/message/MessageContainer';
import RenderOfferDetail from '../shared/campaignTimeline/renderOfferDetail';

function OfferDetail(props) {
  const {
    isOpen, onClose, offerIdObj, artistId, updateRequestStatusClient, updateContractAcceptedStatusClient,
    offerNotificationUpdateClient, activeTab, refetchData,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const [loaderValue, setLoaderValue] = useState(false);
  const [offerData, setOfferData] = useState({});
  const [requested, setRequest] = useState(false);
  const [isSeeContract, setContract] = useState(false);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [updateRequestParams, setUpdateRequestParams] = useState({});
  const [updateRequestStatus, setUpdateRequestStatus] = useState();
  const [artistData, setArtistData] = useState();
  const [isCreateBetaPostModal, setIsCreateBetaPostModal] = useState(false);
  const [modalObj, setModalObj] = useState({});
  const { addToast } = useToasts();
  const [modifyPost, setModifyPost] = useState(false);
  const [sendMessageModal, setSendMessageModal] = useState(false);
  const [sendMessageModalObj, setSendMessageModalObj] = useState(false);

  const toggleSendMessageModal = () => {
    setSendMessageModalObj({ offerId: offerData._id });
    setSendMessageModal(!sendMessageModal);
  };
  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const closeContract = () => {
    setContract(false);
  };

  const toggleCreateBetaPostModal = (betaPostData, isModify) => {
    setModalObj(betaPostData);
    setModifyPost(isModify);
    setIsCreateBetaPostModal(!isCreateBetaPostModal);
  };

  const {
    loading: offerDetailsLoader, error: offerDetailsError, data: offerDetails, refetch: reFetchDetail,
  } = useQuery(GET_OFFER_DETAIL_QUERY, {
    variables: {
      ...offerIdObj,
      artistId,
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (refetchData) {
      reFetchDetail({
        variables: {
          ...offerIdObj,
          artistId,
        },
      });
      props.reSetValue();
    }
  },
  [refetchData]);

  const [updateOfferNotification] = useMutation(UPDATE_OFFER_NOTIFICATION, {
    variables: {},
    update: () => {
      offerNotificationUpdateClient();
    },
  });

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: loaderValue },
  });

  const [getUserDataQuery] = useLazyQuery(GET_USER_DATA_QUERY, {
    onError(err) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },
    onCompleted(data) {
      setArtistData(data.getUser.data);
    },
  });

  const [acceptContract] = useMutation(ACCEPT_CONTRACT, {
    refetchQueries: [{
      query: GET_OFFER_DETAIL_QUERY,
      variables: {
        ...offerIdObj,
        artistId,
      },
    }],
    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },
    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data && data.acceptContract && data.acceptContract.message, { appearance: 'success' });
      setContractAccepted(true);
      const updateContractInfo = { ...offerData };
      updateContractInfo.isContractAccepted = true;
      setOfferData(updateContractInfo);
      reFetchDetail({ variables: { ...offerIdObj, artistId } });
    },
  });

  const [publishBetaPost] = useMutation(PUBLISH_BETA_POST_REQUEST, {
    variables: {},
    refetchQueries: [{
      query: GET_OFFER_DETAIL_QUERY,
      variables: {
        ...offerIdObj,
        artistId,
      },
    }],
    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },
    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.publishBetaPost.message, { appearance: 'success' });
    },
  });

  const handlePublishBetaPost = (reqObj) => {
    loader({ variables: { show: true } });
    publishBetaPost({ variables: { ...reqObj, ...{ offerId: offerIdObj.offerId, artistId } } });
  };

  const seeContract = () => {
    setContract(true);
    getUserDataQuery({
      variables: {
        userId: artistId,
      },
    });
  };

  const renderMsgButton = () => (
    <Button
      type="text"
      color="outline"
      onClick={toggleSendMessageModal}
      className="btn-flex-icon"
    >
      <span className="icon icon-chat" />
      {' '}
      Send message
    </Button>
  );

  const renderMyOffersButtons = (data) => (data && !data.isContractAccepted ? (
    <div className="modal-offer-detail-btn-group">
      <Button
        type="text"
        color="publish"
        onClick={() => { seeContract(); }}
      >
        View Terms
      </Button>
      {offerData && offerData.isContractAccepted && renderMsgButton()}
    </div>
  ) : (
    <div className="modal-offer-detail-btn-group">
      <Button
        color="publish"
        onClick={() => { seeContract(); }}
      >
        See contract
      </Button>
      {renderMsgButton()}
    </div>
  ));

  /* ---- Remove Private offer from local cache ----*/
  const [removePrivateOfferClient] = useMutation(REMOVE_PRIVATE_OFFER_CLIENT, {
    variables: {},
  });

  const [updatePrivateOfferRequest] = useMutation(UPDATE_PRIVATE_OFFER_REQUEST, {
    variables: {},
    refetchQueries: [{
      query: GET_OFFER_DETAIL_QUERY,
      variables: { ...offerIdObj, artistId },
    }],

    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.updateArtistOffer.message, { appearance: 'success' });
      updateRequestStatus && updateRequestStatus === ARTIST_PRIVATE_REQUEST.ARTIST_REMOVED && toggle();
      removePrivateOfferClient({ variables: updateRequestParams });
    },
  });

  function updateStatus(artistUpdateStatus) {
    const { offerId } = offerIdObj;
    setUpdateRequestStatus(artistUpdateStatus);
    setUpdateRequestParams({ offerId, status: ARTIST_OFFER_LIST_STATUS.FOR_ME, artistId });
    updatePrivateOfferRequest({ variables: { offerId, status: artistUpdateStatus, artistId } });
  }

  const [requestParticipation, { loading: requestLoader }] = useMutation(REQUEST_ARTIST_PARTICIPATION, {
    variables: {
      ...offerIdObj,
      artistId,
    },
    onError(error) {
      loader({ variables: { show: false } });
      addToast(error.message || error.graphQLErrors[0].message, { appearance: 'error' });
    },
    onCompleted(artistRequest) {
      setLoaderValue(false);
      loader();
      addToast(artistRequest && artistRequest.artistRequest && artistRequest.artistRequest.message, { appearance: 'success' });
      setRequest(true);
    },
  });

  const requestForParticipation = () => {
    requestParticipation();
  };

  const handlePageScroll = function (e) {
    e.preventDefault();
    const modalBody = document.querySelector('.modal-body');
    const stickObj = document.querySelector('.modal-offer-detail-title')?.offsetTop - NUMERIC_VALUE.TWO_HUNDRED_FIFTY;
    if (e.target.scrollTop > stickObj) {
      modalBody.classList.add('stick-cover');
    } else {
      modalBody.classList.remove('stick-cover');
    }
  };

  const onModalOpened = function () {
    const modalElement = document.querySelector('#offer-modal').parentNode;
    modalElement.addEventListener('scroll', handlePageScroll, false);
  };

  /* add toaster showing error message in case of any error while fetching the offer list data */
  useEffect(() => {
    offerDetailsError
      && addToast(handleGraphqlError(offerDetailsError), { appearance: 'error' });
  },
  [offerDetailsError]);

  useEffect(() => {
    window.onpopstate = () => {
      toggle();
    };
    return () => {
      const modalElement = document.querySelector('#offer-modal')?.parentNode;
      modalElement && modalElement.removeEventListener('scroll', handlePageScroll, false);
    };
  }, []);

  /* set offer list data */
  useEffect(() => {
    if (offerDetails && offerDetails.offerDetail && offerDetails.offerDetail.data) {
      const { data } = offerDetails.offerDetail;
      setOfferData(data);
      setRequest(data.isRequested);
      if (data.isNotification) {
        updateOfferNotification({ variables: { offerId: offerIdObj.offerId, artistId } });
      }
    }
  }, [offerDetails]);

  /* call update requested status mutation */
  useEffect(() => {
    if (requested && updateRequestStatusClient) {
      updateRequestStatusClient(requested);
    }
  }, [requested]);

  /* call update contract accepted status mutation */
  useEffect(() => {
    if (contractAccepted && updateContractAcceptedStatusClient) {
      updateContractAcceptedStatusClient(contractAccepted);
    }
  }, [contractAccepted]);

  if (offerDetailsLoader || requestLoader) {
    return <Loading active />;
  }

  const renderAllOffersButtons = (data) => ((!requested) && (data && !data.isRequested) ? (
    <div className="single-btn-group">
      <Button
        color="primary"
        element="block"
        onClick={() => { requestForParticipation(); }}
      >
        Request for participation
      </Button>
    </div>
  ) : (
    <div className="single-btn-group">
      <Button
        color="request"
        element="block"
      >
        <span className="icon icon-tick" />
        {' '}
        Request sent for approval
      </Button>
      <small className="text-center d-block pt-3">Check your email and notifications on this app for next steps.</small>
    </div>
  )
  );

  const renderAcceptRemoveOffer = () => (
    <div className="modal-offer-detail-btn-group-decline">
      <Button
        type="text"
        color="publish"
        onClick={() => { updateStatus(ARTIST_PRIVATE_REQUEST.ARTIST_ACCEPTED); }}
      >
        Accept opportunity
      </Button>
      <Button
        type="text"
        color="text-red"
        onClick={() => { updateStatus(ARTIST_PRIVATE_REQUEST.ARTIST_REMOVED); }}
      >
        Decline
      </Button>
    </div>
  );

  function renderOffersButtons(data, status) {
    let button;
    const { isArtistParticipation } = data;
    switch (status) {
      case OFFER_STATUS.ADMIN_REQUESTED:
        button = isArtistParticipation ? renderMyOffersButtons(data) : renderAllOffersButtons(data);
        break;
      case OFFER_STATUS.ADMIN_ACCEPTED:
      case OFFER_STATUS.ARTIST_ACCEPTED:
      case OFFER_STATUS.CONTRACT_ACCEPTED:
      case OFFER_STATUS.COMPLETED:
        button = renderMyOffersButtons(data);
        break;
      case OFFER_STATUS.ARTIST_REQUESTED:
      default:
        button = renderAllOffersButtons(data);
        break;
    }
    return button;
  }

  /* returns the html form data using dangerouslySetInnerHtml */
  const createMarkup = (content) => ({ __html: content });

  if (isSeeContract) {
    return (
      <Modal isOpen={modal} className="modal-offer-detail modal-offer-contract">
        <ModalBody>
          <ModalHeader toggle={closeContract} className="modal-blank-header" />
          <div className="modal-heading">
            <h1>{BYGMUSIC_CONTRACT.contractHeader}</h1>
            {!offerData.isContractAccepted && (
              <p>
                {BYGMUSIC_CONTRACT.contractDescriptionStart}
                <span>{BYGMUSIC_CONTRACT.acceptContract}</span>
                {' '}
                {BYGMUSIC_CONTRACT.contractDescriptionEnd}
              </p>
            )}
          </div>
          <div className="contract-data">
            <p dangerouslySetInnerHTML={createMarkup(offerData.createContract)} />
            <div className="contract-data-footer">
              <div className="influencer-data">
                <h2>{BYGMUSIC_CONTRACT.influencer}</h2>
                <p>
                  {BYGMUSIC_CONTRACT.name}
                  <span>{artistData && capitalizeEveryWord(artistData.name)}</span>
                </p>
                <p>
                  {BYGMUSIC_CONTRACT.address}
                  <span>{artistData && artistData.city && artistData.city.label}</span>
                  {artistData && artistData.city && ', '}
                  <span>{artistData && artistData.state && artistData.state.label}</span>
                  {artistData && artistData.state && ', '}
                  <span>{artistData && artistData.country && artistData.country.label}</span>
                </p>
                <p>
                  {BYGMUSIC_CONTRACT.emailAddress}
                  <span>{artistData && artistData.email}</span>
                </p>
                {!offerData.isContractAccepted && (
                  <Button
                    color="primary"
                    onClick={() => {
                      acceptContract({
                        variables: {
                          ...offerIdObj,
                          artistId,
                        },
                      });
                    }}
                  >
                    Accept Terms
                  </Button>
                )}
              </div>
              <div className="bygmusic-data">
                <h2>{BYGMUSIC_CONTRACT.bygMusic}</h2>
                <p>
                  {BYGMUSIC_CONTRACT.name}
                  <span>{BYGMUSIC_CONTRACT.ownerName}</span>
                </p>
                <p>
                  {BYGMUSIC_CONTRACT.title}
                  <span>{BYGMUSIC_CONTRACT.designation}</span>
                </p>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  return (
    <>
      <Modal id="offer-modal" onOpened={onModalOpened} isOpen={modal} className="modal-offer-detail">
        <ModalBody>
          <RenderOfferDetail activeTab={activeTab} toggle={toggle} data={offerData} renderOffersButtons={renderOffersButtons} handlePublishBetaPost={handlePublishBetaPost} />
          <CampaignTimeline
            data={offerData && (offerData.betaPostTimeLine && offerData.betaPostTimeLine.length) > 0
              ? offerData && offerData.betaPostTimeLine : offerData && offerData.campaignTimeline}
            status={offerData && offerData.status}
            segmentId={offerIdObj.segmentId}
            offerMaxDate={offerData && offerData.offerMaxDate}
            offerMinDate={offerData && offerData.offerMinDate}
            toggleCreateBetaPostModal={toggleCreateBetaPostModal}
            handlePublishBetaPost={handlePublishBetaPost}
            isBetaPostAutoApproval={offerData?.isBetaPostApproval}
            isContractAccepted={offerData?.isContractAccepted}
          />
        </ModalBody>
      </Modal>
      {isCreateBetaPostModal && (
        <CreateBetaPost
          isOpen={isCreateBetaPostModal}
          onClose={() => { toggleCreateBetaPostModal(modalObj); }}
          betaPostData={modalObj}
          isModify={modifyPost}
          artistId={artistId}
          offerId={offerIdObj.offerId}
          dueDays={isDateDiff(modalObj, offerData?.status)}
          isBetaPostAutoApproval={offerData?.isBetaPostApproval}
        />
      )}

      {sendMessageModal && sendMessageModalObj && (
        <Message
          offerId={offerIdObj.offerId}
          isOpen={sendMessageModal}
          onClose={toggleSendMessageModal}
          offerMaxDate={offerDetails && offerDetails.data && offerDetails.data.offerMaxDate}
        />
      )}
    </>
  );
}

OfferDetail.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  offerIdObj: PropTypes.shape({
    offerId: PropTypes.string,
    segmentId: PropTypes.string,
  }).isRequired,
  artistId: PropTypes.string.isRequired,
  updateContractAcceptedStatusClient: PropTypes.func,
  updateRequestStatusClient: PropTypes.func,
  offerNotificationUpdateClient: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
};

OfferDetail.defaultProps = {
  updateContractAcceptedStatusClient: null,
  updateRequestStatusClient: null,
};

export default OfferDetail;
